<script lang="ts">
    import { _ } from 'svelte-i18n';

    import type { QuickCategoriesIdType } from './QuickCategoriesConfig';
    import { planning } from '../../../../stores/store.js';
    import { Assignment } from '../Assignment.js';

    export let categoryId: QuickCategoriesIdType = 'to_approve';
    export let assignment: Assignment;
    export let showStartArrow: boolean = false;
    export let showEndArrow: boolean = false;
    export let wider: boolean = false;

    let value: number = 0;
    let currentColor: string = '';
    let currentBackgroundColor: string = '';

    $: value = assignment.getQuickCategories().getQuantity(categoryId);

    $: currentColor = assignment.getQuickCategories().getColor(categoryId);
    $: currentBackgroundColor = assignment.getQuickCategories().getBackgroundColor(categoryId);
</script>

<div style="display: flex; flex-direction: row; align-items: center;">
    {#if showStartArrow}
        <div
            class="arrow-right-start"
            style="border-bottom-color: {currentBackgroundColor}; border-top-color: {currentBackgroundColor};border-left-color: transparent;"
        ></div>
    {/if}
    <div
        class:bold={$planning.currentQuickCategoryId === categoryId}
        class:withColor={true}
        class:wider
        style={'background-color: ' +
            currentBackgroundColor +
            '; color: ' +
            currentColor +
            '; font-weight: 600;'}
        title={$_(categoryId)}
    >
        {#if value > 0}
            {value}
        {:else}
            -
        {/if}
    </div>
    {#if showEndArrow}
        <div class="arrow-right-end" style="border-left-color: {currentBackgroundColor}"></div>
    {/if}
</div>

<style>
    .withColor {
        min-width: 21px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        /*padding: 2px 2px 2px 2px;*/
        line-height: 16px;
        height: 22px;
        /*font-weight: 600;*/
    }
    .arrow-right-end,
    .arrow-right-start {
        width: 0;
        height: 0;
        border-top: 11px solid transparent;
        border-bottom: 11px solid transparent;
        border-left: 3px solid transparent;
    }
    .wider {
        min-width: 75px;
        display: flex;
        justify-content: center;
    }
</style>
